import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import NavBar from "../Utils/NavBar";
import BackDecoration from "../Utils/BackDecoration";
import DoneMessages from "../Utils/DoneMessage";
import Cookies from "universal-cookie";
import OAuthPanel from "../OAuth/OAuthPanel";
import SignUp from "../SignUp/SignUp";
require("../../assets/stylesheets/SignIn/SignIn.css");

const cookie = new Cookies();

function Form() {
  const [content, setContent] = useState({
    username: "",
    password: "",
  });

  const [text, setText] = useState("");
  const [code, setCode] = useState(200);
  const [messageView, setMessageView] = useState(false);
  useEffect(() => {}, [messageView]);

  const handleSubmit = (e) => {
    setMessageView(false);
    e.preventDefault();

    if (handleDisabled) {
      axios
        .post(
          "https://ferias-ingenio-backend.vercel.app/api/users/getuser",
          content
        )
        .then((res) => {
          setText(res.data.message);
          setCode(res.data.code);
          setMessageView(true);
          if (res.data.code == 200) {
            cookie.set("id", res.data.userData.id, { path: "/" });
            cookie.set("username", res.data.userData.username, { path: "/" });
            cookie.set("email", res.data.userData.email, { path: "/" });
            cookie.set("likes", res.data.userData.likes, { path: "/" });
            if (!res.data.doc.admin) {
              if (!res.data.doc.judge) {
                window.location.href = "/categories";
              } else {
                window.location.href = "/judges";
                cookie.set("judge", res.data.doc.judge, { path: "/" });
              }
            } else {
              window.location.href = "/administration";
              cookie.set("admin", res.data.doc.admin, { path: "/" });
            }
          }
        })
        .then((err) => {});

      setContent({
        username: "",
        password: "",
      });
    } else {
      setText("Información Incorrecta");
      setCode(400);
      setMessageView(true);
    }
  };

  const validate = (text) => {
    if (
      text.includes("[") ||
      text.includes("]") ||
      text.includes("{") ||
      text.includes("}") ||
      text.includes('"') ||
      text.includes("|") ||
      text.includes("&") ||
      text.includes("`") ||
      text.includes("*") ||
      text.includes("+") ||
      text.includes(";")
    ) {
      return "inputError";
    } else {
      return "input";
    }
  };

  const handleDisabled = () => {
    if (validate(content.username) == "input") {
      return false;
    } else {
      return true;
    }
  };

  const [formMode, setFormMode] = useState("signIn");
  const changeFormType = () => {
    if (formMode === "signIn") {
      setFormMode("signUp");
    } else {
      setFormMode("signIn");
    }
  };

  return (
    <div className="small-form">
      {messageView && (
        <DoneMessages text={text} code={code} visibility={messageView} />
      )}
      <div className="oauth">
        <h1>Opciones de inico de sesión</h1>
        <div className="auth-buttons">
          <OAuthPanel />
        </div>
      </div>
      {formMode === "signIn" ? (
        <form className="small-formInputs" onSubmit={handleSubmit}>
          <h1>Iniciar con cuenta</h1>
          <div className="input-group">
            <input
              type="text"
              className={`large ${validate(content.username)}`}
              value={content.username}
              onChange={(e) =>
                setContent({ ...content, username: e.target.value })
              }
              required
              name="username"
            />
            <label htmlFor="username" className="input-label">
              Usuario
            </label>
            {validate(content.username) == "inputError" && (
              <p className="onError">No se permiten caracteres especiales</p>
            )}
          </div>
          <div className="input-group">
            <input
              type="password"
              className={`large input`}
              value={content.password}
              onChange={(e) =>
                setContent({ ...content, password: e.target.value })
              }
              required
              name="password"
            />
            <label htmlFor="password" className="input-label">
              Contraseña
            </label>
          </div>
          <button className="small-btnForm" disabled={handleDisabled()}>
            Entrar
          </button>
          <p className="changeForm">
            No tienes cuenta? <p onClick={changeFormType}>Registrate</p>
          </p>
        </form>
      ) : (
        <SignUp>
          <p className="changeForm">
            Ya tienes cuenta? <p onClick={changeFormType}>Inicia Sesión</p>
          </p>
        </SignUp>
      )}
    </div>
  );
}

function SignIn() {
  if (cookie.get("username")) {
    window.location.href = "./categories";
  }
  return (
    <div className="SignIn">
      <BackDecoration />
      <NavBar />
      <Form />
    </div>
  );
}

export default SignIn;
